// extracted by mini-css-extract-plugin
export default {"container":"TestSendAutomatedEmail_container__+cO5R","popup":"TestSendAutomatedEmail_popup__pqiqg","closeBtn":"TestSendAutomatedEmail_closeBtn__yQSEs"};